import React from 'react';
import { Button } from '../components/ui/button';
import { Apple } from 'lucide-react';

const Login = () => {
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  
  const handleAppleLogin = () => {
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?provider=apple&redirect=${encodeURIComponent(redirectUrl)}`;
  };
  
  return (
    <div className="h-[100dvh] flex flex-col bg-white overflow-hidden px-6">
      {/* Centered content */}
      <div className="flex-1 flex flex-col items-center justify-center -mt-8">
        {/* Large Logo - same size as onboarding */}
        <img 
          src="/couplein_logo.png"
          alt="CoupleIn"
          className="h-36 mb-6"
        />
        
        {/* Tagline */}
        <p className="text-gray-400 text-center text-lg">
          Strengthen your bond, together
        </p>
      </div>
      
      {/* Bottom section */}
      <div className="space-y-3 pb-8 safe-bottom">
        <Button
          onClick={handleGoogleLogin}
          data-testid="google-login-btn"
          className="w-full h-14 text-lg rounded-2xl gradient-brand shadow-pink font-semibold text-white"
        >
          <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
            <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continue with Google
        </Button>
        
        <Button
          onClick={handleAppleLogin}
          data-testid="apple-login-btn"
          className="w-full h-14 text-lg rounded-2xl bg-gray-900 text-white hover:bg-gray-800 font-semibold"
        >
          <Apple className="w-5 h-5 mr-3" fill="white" />
          Continue with Apple
        </Button>
        
        <p className="text-xs text-center text-gray-400 pt-2">
          By continuing, you agree to our{' '}
          <a 
            href="/terms" 
            className="underline text-gray-500 hover:text-primary"
            onClick={(e) => { e.preventDefault(); window.open('/terms', '_blank'); }}
          >
            Terms of Service
          </a>
          {' '}&amp;{' '}
          <a 
            href="/privacy" 
            className="underline text-gray-500 hover:text-primary"
            onClick={(e) => { e.preventDefault(); window.open('/privacy', '_blank'); }}
          >
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};

export default Login;
